import React from 'react';
import styled, {css} from 'styled-components';

import {FormGroup} from '../../form-containers/FormGroup';
import {FormLabel} from '../../form-labels/FormLabel';
import {LabeledPrefix, LabeledSuffix} from '../../form-labels/FormLabeledSuffixPrefix';

/**
 * FormDetail is the component you should use whenever you need to display the view mode of any form content.
 * This consists of the FormGroup label and the form entry.
 *
 * @param {object} param0
 *
 * @param {"horz"} [param0.direction]
 * By default, the display position for the form group is set vertically, with the label positioned on top and the entry below it.
 * By using position='horz', you adjust the position vertically with the label being positioned to the left and the entry to the right.
 *
 * @param {string} [param0.label]
 * The text to be displayed as the label.
 *
 * @param {ReactNode} [param0.children]
 * The children of the label.
 *
 * @example
 * ```jsx
 *      <FormDetail label='Detail label'>
 *          Content entry
 *      </FormDetail>
 * ```
 */
export function FormDetail({children, label, direction}) {
    return (
        <Wrapper direction={direction}>
            {label && <FormLabel>{label}</FormLabel>}
            <div> {children}</div>
        </Wrapper>
    );
}

const Wrapper = styled(FormGroup)`
    margin-bottom: var(--space-sm);

    ${FormLabel} {
        margin: 0;
        padding: 0;
    }

    ${LabeledSuffix},
    ${LabeledPrefix} {
        padding: 0 var(--padding-form-control);
    }

    ${({direction}) => {
        if (direction == 'horz') {
            return css`
                margin-bottom: var(--space-xsm);
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: var(--space-xsm);
            `;
        }
    }}
`;
